import { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import appHistory from "../../app/appHistory";
import { useLocation } from "react-router";
import { MobileRouterPaths } from "../mobileAppConstants";
import { Loader } from "../../components/Loader/Loader";
import { createStructuredSelector } from "reselect";
import { getCodeChecked, getIsCheckCodeLoading } from "../../app/appSelectors";
import { checkCodeAction } from "../../modules/Login/loginActions";
import { Redirect } from "react-router-dom";
import { MOBILE_SLIDER_PAGES_IDS } from "../components/MobileSliderPages/mobileSliderPagesConstants";

function MobileAppConfirm(props) {
    const location = useLocation();
    const {checkCode, codeChecked, isCheckCodeLoading} = props;

    const {email, code, justConfirm} = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const email = params.get('email');
        const code = params.get('code');
        const justConfirm = params.get('just-confirm');
        return {email, code, justConfirm}
    }, [location]);

    useEffect(() => {
        if (!email) {
            appHistory.push(MobileRouterPaths.default);
            return;
        }
        checkCode({
            email,
            code,
            failureRedirectLink: MobileRouterPaths.brokenLink,
            confirmEmail: justConfirm,
        });
    }, [checkCode, code, email, justConfirm]);

    return <>
        {
            codeChecked && <Redirect to={{
                pathname: MobileRouterPaths.portfolio,
                search: `?s=${MOBILE_SLIDER_PAGES_IDS.EMAIL_CONFIRMED}`,
                state: {checkEmail: email},
            }}/>
        }
        <Loader show={isCheckCodeLoading}/>
    </>
}

const mapStateToProps = createStructuredSelector({
    codeChecked: getCodeChecked,
    isCheckCodeLoading: getIsCheckCodeLoading,
});

const mapDispatchToProps = (dispatch) => ({
    checkCode: (payload) => dispatch(checkCodeAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileAppConfirm);
